import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store.js';
import {observer} from 'mobx-react';

@observer
class DonateFormUserCampaignFields extends React.Component {
  errorMessageForField = fieldName => (
    this.props.errors[fieldName]
  )

  hasErrorOnField = fieldName => (
    !!this.errorMessageForField(fieldName)
  )

  onDisplayNameChange = (e) => {
    store.donateForm.displayName = e.target.value;
  }

  renderNameField = () => (
    <div className={cx({'ss-error': this.hasErrorOnField('display_name')})}>
      <input
        className='rounded-none rounded-t -mb-px relative'
        data-form-element='name'
        data-parsley-error-message='Please enter your name'
        data-parsley-errors-container='.user-campaign-field-errors'
        data-parsley-not-a-credit-card-number
        id={`${store.donateForm.campaignSlug}_donation_form_display_name`}
        maxLength='110'
        name='displayName'
        onChange={e => this.onDisplayNameChange(e)}
        placeholder='Display Name'
        required='true'
        type='text'
        value={store.donateForm.displayName}
      />
    </div>
  );

  renderCommentField = () => (
    <div className={cx({'ss-error': this.hasErrorOnField('comment')})}>
      <textarea
        className='rounded-none rounded-b -mt-px'
        data-form-element='comment'
        data-parsley-error-message='We think you may have entered your credit card number in the wrong field by accident.'
        data-parsley-not-a-credit-card-number
        id={`${store.donateForm.campaignSlug}_donation_form_comment`}
        name='comment'
        onChange={e => store.donateForm.comment = e.target.value}
        placeholder='Leave a note (optional)'
        type='text'
        value={store.donateForm.comment}
      />
    </div>
  )

  renderAnonymousField = () => (
    <div
      className='input-wrapper anonymous custom-check mt-2'
    >
      <input
        data-form-element='isAnonymous'
        defaultChecked={store.donateForm.isAnonymous}
        id={`${store.donateForm.campaignSlug}_donation_form_anonymous`}
        onChange={e => store.donateForm.isAnonymous = e.target.checked}
        type='checkbox'
      />
      <label htmlFor={`${store.donateForm.campaignSlug}_donation_form_anonymous`}>
        Hide my name on this page
      </label>
    </div>
  );

  render() {
    return(
      <div>
        {this.renderNameField()}
        {this.renderCommentField()}
        <div className='user-campaign-field-errors ss-error'>
          <small className='error ss'>
            {this.errorMessageForField('display_name')}
          </small>
          <small className='error ss'>
            {this.errorMessageForField('comment')}
          </small>
        </div>
        {this.renderAnonymousField()}
      </div>
    );
  }
}

export default DonateFormUserCampaignFields;
